import React from 'react';
import * as Styles from './styles';
export const LinkWrapper = _ref => {
  let {
    adUrl,
    adUrlTarget,
    onClick,
    onAuxClick,
    titleID
  } = _ref;
  return React.createElement(Styles.Link, {
    "data-ds-component": "DS-NewAdCard-Link",
    href: adUrl,
    target: adUrlTarget,
    onClick: onClick,
    onAuxClick: onAuxClick,
    "aria-labelledby": titleID
  });
};
LinkWrapper.displayName = 'LinkWrapper';